/* Scord Athletics - global behaviour
   Mobile drawer, reveal on scroll, sticky offsets.
   Lifted from the approved mockups. Respects prefers-reduced-motion. */
(function () {
  'use strict';

  /* ---- mobile drawer ---- */
  function initDrawer() {
    var burger = document.getElementById('burger');
    var drawer = document.getElementById('drawer');
    if (!burger || !drawer) return;

    function close() {
      drawer.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      burger.setAttribute('aria-label', 'Open menu');
    }

    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') close();
    });

    /* Escape closes it. Not in the mockup, but the size guide modal
       already behaves this way so the site should be consistent. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) {
        close();
        burger.focus();
      }
    });
  }

  /* ---- reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    Array.prototype.forEach.call(els, function (el, i) {
      el.style.transitionDelay = (Math.min(i, 4) * 55) + 'ms';
      io.observe(el);
    });
  }

  /* ---- sticky offset ----
     The mockups pin the drawer at calc(var(--bar) + var(--navh)), which assumes
     the announcement bar is always on screen. It is not: it scrolls away while
     the nav stays sticky, so on mobile the open drawer detaches from the nav by
     the height of the bar. We measure the bar and expose it as --bar-live. */
  function initOffsets() {
    var bar = document.querySelector('.announce');
    var root = document.documentElement;
    function measure() {
      var h = bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
      root.style.setProperty('--bar-live', h + 'px');
    }
    measure();
    window.addEventListener('scroll', measure, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
  }

  function boot() { initDrawer(); initReveal(); initOffsets(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
